import React from 'react';
import { useTranslation } from 'react-i18next';

import SearchInput from '../../../../components/common-inputs/SearchInput';

import scss from './MediaSearch.module.scss';

function MediaSearch({ value, onChange }) {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper}>
      <SearchInput
        value={value}
        onChange={onChange}
        size='sm'
        name='story-media-search'
        placeholder={t('searchMedia')}
      />
    </div>
  );
}

export default MediaSearch;
